exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navigation[data-v-622b059a]{font-size:.9230769231rem}.navigation__group-item[data-v-622b059a]:not(:first-child){margin-top:21px}.navigation__item[data-v-622b059a]{border:1px solid #d5d5d8;border-bottom:0}.navigation__item[data-v-622b059a]:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.navigation__item[data-v-622b059a]:last-child{border-bottom:1px solid #d5d5d8;border-bottom-left-radius:4px;border-bottom-right-radius:4px}", ""]);

// exports
